// export default {
//   apiUrl: process.env.apiUrl,
//   keys: process.env.keys,
//   mc: process.env.mc,
//   hq: process.env.hq,
//   uploadConfig: process.env.uploadConfig,
//   h5: process.env.h5
// }


var url = 'http://plan.cjs.com.cn'
export default {
    mc: {
        appId: 'rGngnUit9fqERRVjQMfzQhWg-gzGzoHsz',
          APIServerURL: 'https://mcappapi.cjs.com.cn/'
    },
    url: url, // 网站域名
   	proApi: "https://cjs-pro-api-test.cjs.com.cn/",
    //proApi: "https://cjs-pro-api.cjs.com.cn/",
    crmApi: "http://10.10.0.32:8012/",
    scrmApi: "https://cjs-scrm-api.cjs.com.cn/",
    // scrmApi: "https://vhall-data.qiankuncloud-ai.com",
    livingApi: "https://lv.qktz.com.cn/",
    vhApi: process.env.VUE_APP_VH_API || "https://vhall-data.qiankuncloud-ai.com",
    // vhApi: process.env.VUE_APP_VH_API || "http://127.0.0.1:5006",
    // H5 直播相关配置
    webAppId: process.env.VUE_APP_WEB_APPID || 'wxa796c1319f80b78e',  // 微信开放平台网站应用 AppID
    webRedirectUrl: process.env.VUE_APP_WEB_REDIRECT || 'https://quanzi.qkdxt.com/pages/common/middleware/index',  // 微信网站应用回调地址（网站应用所在域名，由该域名的项目接收code后传回本H5）
    wxmpAppId: process.env.VUE_APP_WXMP_APPID || 'wx0dd5ea0270024f55',  // 微信公众号 AppID（H5网页授权，微信内浏览器使用）
}
